import { NgModule } from '@angular/core';
import { Routes, RouterModule, } from '@angular/router';
import { ResetPasswordComponent } from './modules/reset-password/reset-password.component';
import { LoginErrorsComponent } from 'src/common-items/components/login-errors/login-errors.component';
import { AppRouteResolver } from 'src/common-items/services/http/configuration';
import { BassScaResetPasswordComponent } from './modules/bass-sca/bass-sca-reset-password.component';
import { PageNotFoundComponent } from 'src/common-items/components/page-not-found/page-not-found.component';

const cpRoutes: Routes = [
  { path: 'resetPassword/:token', component: ResetPasswordComponent, resolve: {groute: AppRouteResolver}},
  { path: 'baas-sca/resetPassword/:token', component: BassScaResetPasswordComponent , resolve: {groute: AppRouteResolver}},
  { path: 'error', component: LoginErrorsComponent },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(cpRoutes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
